/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { useTheme } from "@cd2/theme"

import { Flex } from "./Flex"

interface IToggleSwitchProps {
  on: boolean
  onClick(value: boolean): void
  className?: string
  disabled?: boolean
}

export function ToggleSwitch({ on, onClick, className, disabled }: IToggleSwitchProps) {
  const { themeColor, borderRadius } = useTheme()

  return (
    <div
      className={className}
      css={css`
        position: relative;
        width: 48px;
        height: 26px;
        border-radius: ${borderRadius}px;
        padding: 3px;
        background: ${on ? themeColor("primary") : "white"};
        display: inline-block;
        vertical-align: middle;
        box-shadow: 0 0 0 1px ${themeColor("formBorderColor")};
        transition: 0.3s;
        cursor: pointer;

        ${disabled &&
        css`
          cursor: not-allowed;
          pointer-events: none;
        `}
      `}
      onClick={() => !disabled && onClick(!on)}
    >
      <div
        css={css`
          background: ${themeColor("#f7f7f7")};
          box-shadow:
            0 1px 3px 0 rgba(0, 0, 0, 0.1),
            0 1px 2px 0 rgba(0, 0, 0, 0.06);
          border: 1px solid ${themeColor("formBorderColor")};
          width: 22px;
          height: 100%;
          border-radius: ${borderRadius}px;
          left: ${on ? 20 : 0}px;
          position: relative;
          transition: 0.3s;
        `}
      />
    </div>
  )
}

export function ToggleSwitchField({
  value,
  onChange,
  label,
  disabled,
  description,
}: {
  value: boolean
  onChange(value: boolean): void
  label: string
  disabled?: boolean
  description?: string
}) {
  return (
    <Flex alignItems="center" gap={8}>
      <ToggleSwitch
        css={css`
          flex-shrink: 0;
        `}
        on={value}
        onClick={onChange}
        disabled={disabled}
      />
      <div>
        <label
          css={css`
            display: block;
            ${disabled &&
            css`
              color: grey;
            `}
          `}
        >
          {label}
        </label>
        {description && (
          <div
            css={css`
              color: #636363;
              font-size: 0.875em;
              margin-top: 4px;
            `}
          >
            {description}
          </div>
        )}
      </div>
    </Flex>
  )
}
